import { useContentApi } from '@/composables/useCmsContentApi'
import IbexaFieldTypeIdentifier from '@/enums/IbexaFieldTypeIdentifier'
import type { IbexaField, IbexaRichTextField } from '@/types/Ibexa'
import { snakeToCamelCase } from '@/utils'

const { getContentFields, getCurrentElement } = useContentApi()

// Some content types in Ibexa have a field identifier "name" instead of "title"
const mapNameToTitle = (fields: IbexaField[]) => {
  const nameValue = fields.find(field => field.fieldDefinitionIdentifier === 'name')
  if (!nameValue) return fields

  return [
    ...fields.filter(field => field.fieldDefinitionIdentifier !== 'name'),
    { ...nameValue, fieldDefinitionIdentifier: 'title' },
  ]
}

const fieldValueMapper = <T>(fields: IbexaField[]): T => {
  return fields.reduce((acc, field) => {
    const isRichText = field.fieldTypeIdentifier === IbexaFieldTypeIdentifier.RichText
    const richtextFieldValue = field.fieldValue as IbexaRichTextField

    return ({
      ...acc,
      [snakeToCamelCase(field.fieldDefinitionIdentifier)]: isRichText ? richtextFieldValue.xhtml5output : field.fieldValue
    })
  }, {} as T)
}

export default () => {
  const getRelatedContentFields = async <T>(contentIds: number[]): Promise<T[]> => {
    const result = await Promise.all(contentIds.map(id => getContentFields(id)))
    return result
      .map(mapNameToTitle)
      .map(fieldValueMapper<T>)
  }

  const getRelatedContent = async <T>(contentIds: number[]): Promise<T[]> => {
    return await Promise.all(
      contentIds.map(id => getCurrentElement<T>(id))
    )
  }

  return {
    getRelatedContentFields,
    getRelatedContent,
  }
}
